import React from 'react';

import {Flex, Box, Title, withPadding, Input, Icon, Dropdown} from 'sg-styleguide';
import FilterButton from '../filter-button';
import { lodash } from 'lodash'

const FlexWithPadding = withPadding(Flex);
const BoxWithPadding = withPadding(Box);

const Sidebar = (props) => {
	return (
		<BoxWithPadding
			sm="3"
			padding={props.isPhone ? ['none', 'small', 'x-small', 'small'] : ['none', 'small']}
		>
			<Input
				className="ua-margin-bottom-medium"
				type="text"
				placeholder={window.wizardData.strings.search_placeholder}
				suffix={<Icon size="18" name="search"/>}
				onChange={e => props.searchThemes(e.target.value)}
			/>
			{!props.isPhone ? (
				<div>
					<Title
						level="6"
						color="lighter"
						density="compact"
					>
						{window.wizardData.strings.categories_title}
					</Title>
					<FlexWithPadding
						direction="column"
						gutter="none"
						margin="none"
					>

						<FilterButton
							title={window.wizardData.tags.all}
							selected={ props.currentTag === 'all' ? 'selected' : '' }
							onClick={ props.reset }
						/>

						{
							props.tags.map(function (tag, key) {
								return <FilterButton
									title={ window.wizardData.tags[tag] ? window.wizardData.tags[tag] : tag }
									key={key}
									selected={ props.currentTag === tag ? 'selected' : '' }
									onClick={ e => props.changeCurrentTag(tag) }
								/>
							}, this)
						}
					</FlexWithPadding>
				</div>
			) : (
				<Dropdown
					options={_.transform( props.tags, (result, tag) => {
						result.push( {
							value: tag,
							tag: window.wizardData.tags[tag] ? window.wizardData.tags[tag] : tag
						} )
					},[])}
					optionValue="value"
					placeholder={window.wizardData.tags.all}
					optionLabel="tag"
					onChange={ e => props.changeCurrentTag(e) }
				/>
			) }
		</BoxWithPadding>
	)
}

export default Sidebar;